import functions from "../../../../../world/spa/libs/vuexFunctions";

export default {
  namespaced: true,
  state: {
    objs: []
  },
  getters: {
    ...functions.createDefaultGetters()
  },
  mutations: {
    ...functions.createDefaultMutations()
  },
  actions: {
    ...functions.createDefaultActionsWithStore()
  }
};
